import 'mini-global-styles'; // Import here to include globalStyles
import 'mini-mail-list-store';

export { default as bootstrapMailModule } from './bootstrapMailModule';
